import styled from 'styled-components';

export const Nav = styled.nav`
  margin-bottom: 30px;
  
  @media (max-width: 768px) {
    margin-top: 30px;
  }
`;
